<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="detail_dialog" top="10vh" :fullscreen="isExpand"
    :show-close="false" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
    <template slot="title">
      <div class="default-dialog-title-box">
        <span>开通云仓</span>
        <span class="icon-box">
          <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
          <i class="el-icon-close" @click="handleClose"></i>
        </span>
      </div>
    </template>
    <div class="content">
      <el-form :model="form" ref="JZForm" :rules="rules" label-position="right" label-width="120px" size="mini" style="margin-top: 10px;">
        <el-row>
          <el-col :span="24">
            <el-form-item label="云仓Logo" prop='storeLogo' style="min-width: 220px;">
              <Upload
                v-model.trim="logoLists"
                label="云仓Logo"
                @success="handleFileLists"
                @remove="handleRemove"
                accept="image/png,image/jpeg,image/jpg"
                :maxSize="5"
                size="small"
                :tip="false"
                :limit="1"
              >
              </Upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="云仓类型" :rules="[{required: true}]" prop="type">
              <el-input v-model.trim="form.type" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="云仓名称" prop="storeName">
              <el-input placeholder="请输入" v-model.trim="form.storeName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="云仓简介" prop="storeDesc">
              <el-input v-model.trim="form.storeDesc" type="textarea" :rows="5" show-word-limit placeholder="输入云仓简介，助力客户快速了解"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="userInfo.isPersonal">
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人姓名" prop="linkName">
                <el-input placeholder="请输入" v-model.trim="form.linkName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人电话" prop="linkPhone">
                <el-input placeholder="请输入" v-model.trim="form.linkPhone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="仓库地址" prop="salesConsigneeAddressPath">
                <area-cascader
                  v-if="isShowAreaCascader"
                  :provinceId.sync="addrForm2.provinceId"
                  :provinceName.sync="addrForm2.provinceName"
                  :cityId.sync="addrForm2.cityId"
                  :cityName.sync="addrForm2.cityName"
                  :areaId.sync="addrForm2.areaId"
                  :areaName.sync="addrForm2.areaName"
                  @areaChange="areaChange(2)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="salesConsigneeDetail" label-width="0px">
                <el-input v-model="form.salesConsigneeDetail" placeholder="请输入详细地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="电子邮箱" prop="linkEmail">
                <el-input placeholder="请输入" v-model.trim="form.linkEmail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行名称" prop="settlementBankAccountName">
                <el-input placeholder="请输入" v-model.trim="form.settlementBankAccountName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="银行账户" prop="settlementBankAccountNum">
                <el-input placeholder="请输入" v-model.trim="form.settlementBankAccountNum" type="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <el-row>
            <el-col :span="12">
              <el-form-item label="企业名称" prop="companyName">
                <el-input placeholder="请输入" v-model.trim="form.companyName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码" prop="licenseNum">
                <el-input placeholder="请输入" v-model.trim="form.licenseNum"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="注册资金" prop="registeredCapital">
                <el-input placeholder="请输入" v-model.trim="form.registeredCapital" type="number">
                  <template slot="append">万元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="人员规模" prop="employeeNum">
                <el-input placeholder="请输入" v-model.trim="form.employeeNum" type="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="经营范围" prop="scope">
                <el-input v-model.trim="form.scope" type="textarea" :rows="5" show-word-limit placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="公司地址" prop="companyAddressPath">
                <area-cascader
                  v-if="isShowAreaCascader"
                  :provinceId.sync="addrForm.provinceId"
                  :provinceName.sync="addrForm.provinceName"
                  :cityId.sync="addrForm.cityId"
                  :cityName.sync="addrForm.cityName"
                  :areaId.sync="addrForm.areaId"
                  :areaName.sync="addrForm.areaName"
                  @areaChange="areaChange(1)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="companyAddress" label-width="0px">
                <el-input v-model="form.companyAddress" placeholder="请输入详细地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="仓库地址" prop="salesConsigneeAddressPath">
                <area-cascader
                  v-if="isShowAreaCascader"
                  :provinceId.sync="addrForm2.provinceId"
                  :provinceName.sync="addrForm2.provinceName"
                  :cityId.sync="addrForm2.cityId"
                  :cityName.sync="addrForm2.cityName"
                  :areaId.sync="addrForm2.areaId"
                  :areaName.sync="addrForm2.areaName"
                  @areaChange="areaChange(2)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="salesConsigneeDetail" label-width="0px">
                <el-input v-model="form.salesConsigneeDetail" placeholder="请输入详细地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="公司电话" prop="companyPhone">
                <el-input placeholder="请输入" v-model.trim="form.companyPhone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电子邮箱" prop="companyEmail">
                <el-input placeholder="请输入" v-model.trim="form.companyEmail"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人姓名" prop="linkName">
                <el-input placeholder="请输入" v-model.trim="form.linkName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人电话" prop="linkPhone">
                <el-input placeholder="请输入" v-model.trim="form.linkPhone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="银行名称" prop="settlementBankAccountName">
                <el-input placeholder="请输入" v-model.trim="form.settlementBankAccountName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行账户" prop="settlementBankAccountNum">
                <el-input placeholder="请输入" v-model.trim="form.settlementBankAccountNum"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="营业执照" prop='licencePhoto'>
                <Upload
                  v-model.trim="licencePhotoList"
                  label="营业执照"
                  @success="handleFileLists2"
                  @remove="handleRemove2"
                  accept="image/png,image/jpeg,image/jpg"
                  :maxSize="10"
                  size="small"
                  :tip="false"
                  :limit="10"
                >
                </Upload>
                <div class="tip-upload">请确保证件完整，编号、印章、文字、照片清楚可见</div>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
    </div>
    <div class="dialog-footer" style="text-align: right;">
      <el-button plain @click="handleClose">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { companyDetail } from '@/api/company';
import { getDetailTenantInformationInfo } from '@/api/systemSetting';
import AreaCascader from '@/components/common/areaCascader';
import { getTenantDetail, getMarketStoreByLicenseNum, getMarketStoreByLinkPhone, addMarketStore, updateMarketStore } from '@/api/shop';
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  components: {
    Upload: ()=>import('@/components/common/upload'),
    AreaCascader,
  },
  data () {
    return {
      isShowAreaCascader: false,
      dialogVisible: false,
      isExpand: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      logoLists: [],
      licencePhotoList: [],
      userInfo: {},
      form: {
        type: '',
        id: undefined,
        storeLogo: '',
        storeName: '',
        storeDesc: '',
        companyName: '',
        licenseNum: '',
        registeredCapital: '',
        employeeNum: '',
        scope: '',
        companyAddressPath: '',
        companyAddress: '',
        salesConsigneeAddressPath: '',
        salesConsigneeDetail: '',
        companyPhone: '',
        companyEmail: '',
        storeType: '2',
        linkName: '',
        linkPhone: '',
        linkEmail: '',
        settlementBankAccountName: '',
        settlementBankAccountNum: '',
        licencePhoto: [],
        legalId: '',
        legalName: '',
        legalPhoto: '',
        storeAddressDetail: '',
        storeAddressPath: '',
      },
      addrForm: {
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
      },
      addrForm2: {
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
      },
      rules: {
        storeLogo: [
          { required: true, validator: this.validateStorePhoto },
        ],
        storeName: [
          { required: true, message: '请填写云仓名称', trigger: ['blur', 'change'] },
        ],
        companyName: [
          { required: true, message: '请填写企业名称', trigger: ['blur', 'change'] },
        ],
        licenseNum: [
          { required: true, message: '请填写统一社会信用代码', trigger: ['blur', 'change'] },
        ],
        registeredCapital: [
          { required: true, message: '请填写注册资金', trigger: ['blur', 'change'] },
        ],
        employeeNum: [
          { required: true, message: '请填写人员规模', trigger: ['blur', 'change'] },
        ],
        companyAddressPath: [
          { required: true, message: '请选择公司地区', trigger: ['blur', 'change'] },
        ],
        companyAddress: [
          { required: true, message: '请填写公司详细地址', trigger: ['blur', 'change'] },
        ],
        salesConsigneeAddressPath: [
          { required: true, message: '请选择仓库地区', trigger: ['blur', 'change'] },
        ],
        salesConsigneeDetail: [
          { required: true, message: '请填写仓库详细地址', trigger: ['blur', 'change'] },
        ],
        linkName: [
          { required: true, message: '请填写联系人姓名', trigger: ['blur', 'change'] },
        ],
        linkPhone: [
          { required: true, message: '请填写联系人电话', trigger: ['blur', 'change'] },
        ],
        linkEmail: [
          { validator: this.validateEmail },
        ],
        companyEmail: [
          { validator: this.validateEmail },
        ],
        settlementBankAccountNum: [
          { validator: this.validateBankAccont },
        ],
        licencePhoto: [
          { required: true, validator: this.validateLicencePhoto },
        ],
      },
    };
  },
  watch: {
    dialogVisible (v) {
      if (!v) {
        this.$refs.JZForm.clearValidate();
      } else {
        this.init();
      }
    },
  },
  methods: {
    validateStorePhoto  (rule, value, callback) {
      if (!this.logoLists.length) {
        callback(new Error('请上传云仓Logo'));
      } else {
        callback();
      }
    },
    validateEmail (rule, value, callback) {
      if (value && !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(value)) {
        callback(new Error('电子邮箱格式错误'));
      } else {
        callback();
      }
    },
    validateBankAccont (rule, value, callback) {
      if (value && !/^\d{16,19}$/.test(value)) {
        callback(new Error('银行账户格式不正确'));
      } else {
        callback();
      }
    },
    validateLicencePhoto  (rule, value, callback) {
      if (!value || !value.length) {
        callback(new Error('请上传营业执照'));
      } else {
        callback();
      }
    },
    areaChange (type) {
      if (type === 1) {
        this.form.companyAddressPath = this.addrForm.areaName ? [this.addrForm.provinceName, this.addrForm.cityName, this.addrForm.areaName].join(',') : '';
      }
      if (type === 2) {
        this.form.salesConsigneeAddressPath = this.addrForm2.areaName ? [this.addrForm2.provinceName, this.addrForm2.cityName, this.addrForm2.areaName].join(',') : '';
      }
    },
    handleRemove () {
      this.form.storeLogo = '';
      this.$refs.JZForm.validateField('storeLogo');
    },
    handleFileLists (file) {
      this.form.storeLogo = file.url;
      this.$refs.JZForm.clearValidate('storeLogo');
    },
    handleRemove2 (file) {
      const index = this.licencePhotoList.findIndex(v => v.url === file.url);
      this.licencePhotoList.splice(index, 1);
      this.form.licencePhoto = this.licencePhotoList.map(img => img.url);
      this.$refs.JZForm.validateField('licencePhoto');
    },
    handleFileLists2 (file) {
      this.licencePhotoList.push(file);
      this.form.licencePhoto = this.licencePhotoList.map(img => img.url);
      this.$refs.JZForm.clearValidate('licencePhoto');
    },
    handleClose () {
      this.dialogVisible = false;
    },
    save () {
      this.$refs.JZForm.validate().then(async valid =>{
        if (valid) {
          const api = this.id ? updateMarketStore : addMarketStore;
          delete this.form.type;
          if (this.userInfo.isPersonal) {
            const person = {
              id: this.form.id,
              storeLogo: this.form.storeLogo,
              storeName: this.form.storeName,
              storeDesc: this.form.storeDesc,
              linkName: this.form.linkName,
              linkPhone: this.form.linkPhone,
              linkEmail: this.form.linkEmail,
              settlementBankAccountName: this.form.settlementBankAccountName,
              settlementBankAccountNum: this.form.settlementBankAccountNum,
              storeType: this.form.storeType,
              marketType: '2',
              salesConsigneeAddressPath: this.form.salesConsigneeAddressPath,
              salesConsigneeDetail: this.form.salesConsigneeDetail,
            };
            // console.log(api, person);
            await api(person);
          } else {
            const params = {
              ...this.form,
              marketType: '1',
              registeredCapital: parseFloat(this.form.registeredCapital),
              licencePhoto: (this.form.licencePhoto || []).join(','),
            };
            // console.log(api, params);
            await api(params);
          }
          this.$message.success('申请已提交');
          this.dialogVisible = false;
          this.$emit('refresh');
        }
      });
    },
    async getCompanyDetail () {
      const { body } = await getTenantDetail({
        keyword: this.form.licenseNum,
      });
      if (body) {
        this.form.legalId = body.enterprise?.legalPersonCertCode;
        this.form.legalName = body.enterprise?.legalPersonName;
        this.form.storeAddressDetail = body.enterprise?.registerAddress;
        this.form.storeAddressPath = [body.enterprise?.registerProvinceName, body.enterprise?.registerCityName, body.enterprise?.registerAreaName].filter(i => i).join('');
      }
    },
    queryDetailTenantInformationInfo () {
      getDetailTenantInformationInfo({
        type: '1',
        dataType: '1',
      }).then(({body}) => {
        const tenantBaseInfo = body.tenantBaseInfoRespDTO;
        const tenantBankAccountInfo = body.tenantCertificateInfoRespDTOs.find(item => item.type === '14') || {};
        const tenantLicencePhotoInfo = body.tenantCertificateInfoRespDTOs.find(item => item.type === '6') || {};
        this.form.registeredCapital = tenantBaseInfo.registeredCapital ? parseFloat(tenantBaseInfo.registeredCapital) : null;
        this.form.employeeNum = tenantBaseInfo.scale;
        this.form.scope = tenantBaseInfo.businessRange;
        this.addrForm = {
          provinceId: tenantBaseInfo.registerProvinceId,
          provinceName: tenantBaseInfo.registerProvinceName,
          cityId: tenantBaseInfo.registerCityId,
          cityName: tenantBaseInfo.registerCityName,
          areaId: tenantBaseInfo.registerAreaId,
          areaName: tenantBaseInfo.registerAreaName,
        };
        this.areaChange(1);
        this.form.companyAddress = tenantBaseInfo.registerAddrs;
        this.form.settlementBankAccountName = tenantBankAccountInfo.bankName;
        this.form.settlementBankAccountNum = tenantBankAccountInfo.bankAccount;
        if (tenantLicencePhotoInfo?.tenantFileReqDTOs?.length) {
          tenantLicencePhotoInfo.tenantFileReqDTOs.map(img => {
            this.licencePhotoList.push({ url: img.url, name: img.name });
            this.form.licencePhoto.push(img.url);
          });
        }
      });
    },
    init () {
      this.isShowAreaCascader = false;
      this.logoLists = [];
      this.licencePhotoList = [];
      this.userInfo = JSON.parse(this.$local.get('userInfo')) || {};
      if (this.id) {
        // 查询云仓信息
        if (!this.userInfo.isPersonal) {
          const certCode = this.userInfo.certCode;
          if (certCode) {
            getMarketStoreByLicenseNum({ licenseNum: certCode }).then(res => {
              const storeInfo = res.body || {};
              this.form = {
                type: '企业',
                ...storeInfo,
                storeType: storeInfo.storeType || '2',
                licencePhoto: [],
              };
              this.logoLists = [ { url: storeInfo.storeLogo, name: 'logo' } ];
              (storeInfo.licencePhoto || '').split(',').map(url => {
                this.licencePhotoList.push({ url: url, name: url });
                this.form.licencePhoto.push(url);
              });
              const companyAddressPath = storeInfo.companyAddressPath?.length ? storeInfo.companyAddressPath.split(',') : null;
              if (companyAddressPath) {
                this.addrForm = {
                  provinceId: '',
                  provinceName: companyAddressPath[0],
                  cityId: '',
                  cityName: companyAddressPath[1],
                  areaId: '',
                  areaName: companyAddressPath[2],
                };
              }
              this.areaChange(1);
              const salesConsigneeAddressPath = storeInfo.salesConsigneeAddressPath?.length ? storeInfo.salesConsigneeAddressPath.split(',') : null;
              if (salesConsigneeAddressPath) {
                this.addrForm2 = {
                  provinceId: '',
                  provinceName: salesConsigneeAddressPath[0],
                  cityId: '',
                  cityName: salesConsigneeAddressPath[1],
                  areaId: '',
                  areaName: salesConsigneeAddressPath[2],
                };
              }
              this.areaChange(2);
              this.isShowAreaCascader = true;
            });
          } else {
            this.$message.warning('企业营业执照号不存在！');
          }
        }
        if (this.userInfo.isPersonal) {
          getMarketStoreByLinkPhone({ linkPhone: this.userInfo.phoneNumber }).then(res => {
            const storeInfo = res.body || {};
            this.form = {
              type: '个人',
              ...storeInfo,
              storeType: storeInfo.storeType || '2',
            };
            this.logoLists = [ { url: storeInfo.storeLogo, name: 'logo' } ];
            const salesConsigneeAddressPath = storeInfo.salesConsigneeAddressPath?.length ? storeInfo.salesConsigneeAddressPath.split(',') : null;
            if (salesConsigneeAddressPath) {
              this.addrForm2 = {
                provinceId: '',
                provinceName: salesConsigneeAddressPath[0],
                cityId: '',
                cityName: salesConsigneeAddressPath[1],
                areaId: '',
                areaName: salesConsigneeAddressPath[2],
              };
            }
            this.areaChange(2);
            this.isShowAreaCascader = true;
          });
        }
      } else {
        companyDetail({id: this.userInfo.tenantId}).then(res => {
          this.form.type = this.userInfo.isPersonal ? '个人' : '企业';
          this.form.storeLogo = res.body.logo;
          this.form.companyName = res.body.name;
          this.form.licenseNum = res.body.certCode;
          this.form.linkName = this.userInfo.isPersonal ? this.userInfo.name : res.body.authenticationAdminName;
          this.form.linkPhone = this.userInfo.isPersonal ? this.userInfo.phoneNumber : res.body.authenticationAdminPhone;
          this.form.linkEmail = this.userInfo.isPersonal ? this.userInfo.email : '';
          this.isShowAreaCascader = true;

          if (!this.userInfo.isPersonal) {
            this.getCompanyDetail();
            this.queryDetailTenantInformationInfo();
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.detail_dialog {

  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }

  .content {
    padding-right: 10px;
    .tip-upload {
      font-weight: 400;
      font-size: 14px;
      color: #929AA6;
    }
  }
}
</style>
